import { AnimatePresence } from 'framer-motion'

import { Interviewer } from '@pkg/types/interview'

import { InterviewerItem } from '../InterviewerItem'

interface InterviewersListProps {
  interviewers: Interviewer[]
}

export const InterviewersList = ({ interviewers }: InterviewersListProps) => (
  <AnimatePresence mode="popLayout">
    {interviewers?.map((interviewer) => (
      <InterviewerItem
        key={interviewer.id || interviewer.email}
        interviewer={interviewer}
      />
    ))}
  </AnimatePresence>
)
